
























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import getActivityType from '@/common/utils/getActivityType';
import getUrlParam from '@/common/utils/getUrlParam';
import CONFIG from '@/common/config';
import fetch from '@/common/api/fetch';
@Component
export default class SelectInstNotice extends Vue {
  @Prop() show!: boolean;
  @Prop() type!: string;

  @Getter('mainTextColor') mainTextColor!: string;
  activityType: string = getActivityType();
  enterType: string = getUrlParam('enterType') as string;
  XMCounter: boolean = true;
  mounted() {}

  close() {
    this.$emit('close');
  }

}
